import React, { ReactElement, useEffect } from 'react';
import { useErrorHandler } from 'react-error-boundary';
import { generatePath, useHistory, useParams } from 'react-router-dom';

import { Layout, Spinner } from 'elmo-elements';

import { useGetElearningQuery, useGetReviewersQuery } from '@/modules/services';
import { ElearningParamType, ModuleSetupRoutes } from '@/pages/Module/routes';

import Header from '@/pages/Module/components/Header';
import NoReviewersMessage from './components/NoReviewersMessage';
import ReviewersList from './components/ReviewersList';
import ReviewerModal from './components/ReviewerModal';

const ElearningReviewers = (): ReactElement => {
  const handleError = useErrorHandler();
  const history = useHistory();
  const { elearningId } = useParams<ElearningParamType>();

  const reviewers = useGetReviewersQuery(elearningId);
  const { data: elearningData } = useGetElearningQuery(elearningId);

  useEffect(() => {
    if (!elearningData) return;

    // Redirect when module has not yet been published to NCB
    if (!elearningData?.statusMetadata.publishedToReview) {
      history.replace(generatePath(ModuleSetupRoutes.path, { elearningId }));
    }
  }, [elearningData]);

  if (reviewers.isError) {
    handleError(reviewers.error);
  }

  return (
    <>
      <Layout.Header>
        <Header />
      </Layout.Header>
      <Layout.Content>
        {!reviewers.isError && reviewers.isLoading ? (
          <Spinner
            id="ElearningReviewersLoading"
            size="s"
            ariaLabel="ElearningReviewers Loading"
          />
        ) : (
          <>
            {reviewers.data && reviewers.data.length ? (
              <ReviewersList ReviewersListData={reviewers.data} />
            ) : (
              <NoReviewersMessage />
            )}
            <ReviewerModal />
          </>
        )}
      </Layout.Content>
    </>
  );
};

export default ElearningReviewers;
